
<template>
  <v-layout row>
    <v-dialog v-model="tlResults.dialog"
              max-width="600px">
        <v-card>
          <v-card-title class="title blue-title pa-3 pt-4 ml-2">
            TL Results
            <div class="header-close" title="close" @click="tlResults.dialog = false">
              <v-icon>close</v-icon>
            </div>
          </v-card-title>
          <v-card-text>
            <v-form ref="forms">
            <v-container grid-list-md pa-0 px-2>
              <v-layout wrap>
                <v-flex xs3>Score：</v-flex>
                <v-flex xs9>{{result.Score}}</v-flex>
                <v-flex xs3>Status：</v-flex>
                <v-flex xs9>{{result.StatusStr}}</v-flex>
                <v-flex xs3>Pros: </v-flex>
                <v-flex xs9>{{result.GoodReview}}</v-flex>
                <v-flex xs3>Cons: </v-flex>
                <v-flex xs9>{{result.BadReview}}</v-flex>
                <v-flex xs3>Creation time: </v-flex>
                <v-flex xs9>{{result.OperaTimeStr}}</v-flex>
              </v-layout>
            </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-4">
            <v-layout justify-center>
              <v-btn class="text-none red-button dialog-submit"
                @click="tlResults.dialog=false">Confirm</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { getTLResultDetail} from '@/api/trainning.js'
export default {
    name: 'tlResults',
    props: {
        tlResults: {
            dialog: false,
            id:0,
            trainingType:0
        }
    },
    data:()=>({
        result:{
          Status: 0,
          StatusStr:'',
          Score: 0,
          BadReview: "",
          GoodReview: "",
          OperaTimeStr:""
        }
    }),
    mounted(){
      this.getTLResults();
    },
    methods:{
        getTLResults(){
          getTLResultDetail(this.tlResults.id,this.tlResults.trainingType).then(res=>{
            if(res.data.ErrorCode===0 &&res.data.Body){
              this.result = res.data.Body
            }
          })
        }
    }
}
</script>